<app-label isBig><ng-content></ng-content></app-label>
<div *ngIf="hasDashedLine" class="dashed-line"></div>
